
export function addEventListeners(selector: string, eventName: string, handler: (event) => void) {
    const elements = find(selector);

    Array.prototype.map.call(elements, element => {
        element.addEventListener(eventName, handler);
    });
}

export function find(selector: string): NodeListOf<HTMLElement> {
    return document.querySelectorAll(selector);
}

export function findAsArray(selector: string): [HTMLElement] {
    const htmlElements = find(selector);
    return [...htmlElements] as [HTMLElement];
}

export function first(selector: string): HTMLElement | null {
    return document.querySelector(selector);
}

export function onDocumentReady(func: () => void) {
    if ((document as any).attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
        func();
    } else {
        document.addEventListener('DOMContentLoaded', func);
    }
}

export function stringToElements(html: string): [HTMLElement] {
    const container = document.createElement('div');
    container.innerHTML = html;
    return [...container.children] as [HTMLElement];
}

export function remove(element: HTMLElement | null) {
    if (element == null || element.parentNode == null) {
        return;
    }

    element.parentNode.removeChild(element);
}

export function setFocus(selector: string): void {
    const element = first(selector);
    if (element) {
        element.focus();
    }
}

export function toggleClass(selector: string, className: string) {
    const element = first(selector);
    if (element) {
        element.classList.toggle(className);
    }
}